import getApiUrl from "./getUrl";
import getUrl from "./getUrl";

export async function fetchAdapters() {
    try {

        const res = await fetch(getUrl()+"/api/adapters", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include", // Include cookies with the request
        });
        return res
    } catch (err) {
    }
}